import request from '@/utils/request'

export function fetchQrCode() {
  return request({
    url: '/admin/fetch_qr_code',
    method: 'post',
  })
}



// WEBPACK FOOTER //
// ./src/api/qrcode.js